module.exports = "/_next/static/videos/video-72c32abd206fe208b5598cd124c191d4.mp4";